import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import FadeIn from '../components/FadeIn';
import allProducts from '../data/products.json';
import SEO from '../components/SEO';

const HOME_CATS = [
  { slug: 'elektromos', label: 'Elektromos kerékpár',  count: '24 modell',  bg: '#1A1A3E', accent: '#818cf8', img: 'https://res.cloudinary.com/dox0o1g92/image/upload/f_auto,q_auto,w_800,c_limit/res_fa2386894b42209d1be93240579e0a12_tgxpld' },
  { slug: 'tura',       label: 'Túrakerékpár',         count: '90 modell',  bg: '#0D3320', accent: '#4ade80', img: 'https://res.cloudinary.com/dox0o1g92/image/upload/f_auto,q_auto,w_800,c_limit/res_cf3cd8e2b557dafb892ba4b3af15f005_qpoflc' },
  { slug: 'varosi',     label: 'Városi kerékpár',      count: '120 modell', bg: '#7C1D0D', accent: '#fb923c', img: 'https://res.cloudinary.com/dox0o1g92/image/upload/f_auto,q_auto,w_800,c_limit/1-leader-fox-park-city-e-bike-e-city-elektromos-kerekpar-bicikli-2021-shimano-bafang-tourney-shimano-36v-250w-13ah-468wh-agymotor_wlpelm' },
  { slug: 'gyermek',   label: 'Gyermekkerékpár',      count: '80 modell',  bg: '#7A3A00', accent: '#fbbf24', img: 'https://res.cloudinary.com/dox0o1g92/image/upload/f_auto,q_auto,w_800,c_limit/Gyerek-ker_C3_A9kp_C3_A1r-Kreativ-2041-20-modell-2019_cwewvb' },
  { slug: 'mtb',        label: 'MTB kerékpár',         count: '68 modell',  bg: '#1C2D0A', accent: '#86efac', img: 'https://res.cloudinary.com/dox0o1g92/image/upload/f_auto,q_auto,w_800,c_limit/cruisershop/products/29-koliken-strion-s-es-kerekpar-latte-noi.webp' },
  { slug: 'haromkereku',label: 'Háromkerekű',          count: '6 modell',   bg: '#2C1654', accent: '#c084fc', img: 'https://res.cloudinary.com/dox0o1g92/image/upload/f_auto,q_auto,w_800,c_limit/cruisershop/products/ezust-haromkereku-kerekpar.jpg' },
];


const WHY = [
  {
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>),
    title: 'Szakértő tanácsadás',
    desc: 'Segítünk kiválasztani a hozzád illő kerékpárt — személyesen, elfogultság nélkül.',
  },
  {
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>),
    title: 'Gyors kiszolgálás',
    desc: 'Raktárkészletről azonnal viheted haza — nincs várás, nincs felesleges köröző.',
  },
  {
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>),
    title: 'Személyes beüzemelés',
    desc: 'Minden kerékpárt szakszerűen beüzemelünk és bemutatunk neked személyesen.',
  },
  {
    icon: (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>),
    title: 'Legjobb árak',
    desc: 'Versenytárs-árakon hozzuk el a legjobb márkák kerékpárait egyenesen hozzád.',
  },
];

// FIX 2: "Verified vásárló" → "Elégedett ügyfél"
const TESTIMONIALS = [
  { name: 'csaba19870221', city: 'Elégedett ügyfél', stars: 5, text: 'Korrekt eladó és gyors kiszolgálás. Sajnos az ünnepek közbeszóltak, így két hét volt, mire megkaptam a kerékpárvillát, amire szükségem volt. Ettől függetlenül minden rendben zajlott. Az eladó nem csak eladó, hanem ért is hozzá. Mindenkinek ajánlom a boltot!' },
  { name: 'H. Márió', city: 'Elégedett ügyfél', stars: 5, text: 'Nagyon segítőkész volt a szerelő, minden rendben zajlott a javítással. Csak ajánlani tudom!' },
  { name: 'B. Bernadett', city: 'Baja', stars: 5, text: 'Nagyon kedves és segítőkész szolgáltató! Alig egy órája érkeztünk pár napos szabadságra Bajára, amikor észrevettük, hogy az otthonról hozott bicikli defektes. Felkerestük az üzletet, és elvállalták a javítást. Mindössze egy óra múlva már mehettünk is érte. A tulajdonos nagyon kedvesen sok programtippet is adott nekünk. Csak ajánlani tudom!' },
  { name: 'K. Péter', city: 'Elégedett ügyfél', stars: 5, text: 'Második biciklit vásároltuk itt. A srác nagyon korrekt, előre nem kér egy fillért sem, az árak jóval a netes árak alatt vannak. 600 db van raktáron, szó szerint meg is mutatta nekünk őket. Nagyon elégedettek vagyunk!' },
  { name: 'K. Ádám', city: 'Baja', stars: 5, text: 'Nem drága, a tulajdonos rendes és segítőkész. Ha szervizelni kell a bringát, rugalmas és gyors, sokszor még aznap kész a munkával. Nagy választék van jó minőségű új biciklikből. Ajánlom!' },
  { name: 'B. Tímea', city: 'Elégedett ügyfél', stars: 5, text: 'Profi és hozzáértő kiszolgálás. Türelmes, kedves és barátságos eladó. Csodás biciklit tudtam nála vásárolni. Csak ajánlani tudom!' },
  { name: 'M. Gabriella', city: 'Elégedett ügyfél', stars: 5, text: 'Meglepően széles választék, készséges és hozzáértő kiszolgálás.' },
  { name: 'K. Péter', city: 'Baja', stars: 5, text: 'Baja legjobb kerékpárboltja! Udvarias kiszolgálás, jó árak, hatalmas bringaválaszték és tökéletes szerviz. Ajánlom!' },
  { name: 'K. Attila', city: 'Elégedett ügyfél', stars: 5, text: 'Barátságos kiszolgálás, elfogadható árak, minőségi árucikkek.' },
  { name: 'N. Richárd', city: 'Elégedett ügyfél', stars: 5, text: 'Profi szakértelem, hatalmas választék, olcsó árak, kedves és segítőkész kiszolgálás.' },
  { name: 'R. Bozso', city: 'Elégedett ügyfél', stars: 5, text: 'Többször vásároltam náluk, nagyon meg vagyok elégedve. Ez egy jó kerékpárüzlet, mindenkinek ajánlom!' },
  { name: 'G. Mária', city: 'Elégedett ügyfél', stars: 5, text: 'Gyors, pontos, precíz és nagyon udvarias kiszolgálás.' },
  { name: 'T. Tibor', city: 'Elégedett ügyfél', stars: 5, text: 'Segítőkész és gyors kiszolgálás.' },
  { name: 'D. Marie-lyse', city: 'Baja', stars: 5, text: 'Szerintem Baján az egyik legjobb üzlet! Mindenkinek aki megbízható boltot és kerékpárt keres csak ajánlani tudom!!!' },
  { name: 'H. Gergely', city: 'Elégedett ügyfél', stars: 5, text: 'A feleségemnek itt vettem meg a kerékpárját. Imádja! Szuper üzlet, jó fej tulajdonossal, remek munkaerővel!' },
  { name: 'A. Marcsi', city: 'Elégedett ügyfél', stars: 5, text: 'Egy üzlet ahol nem úgy néznek rád, hogy minek jöttél! Figyelmes, segítőkész, megold mindent! Leginkább az első szempont, első a VÁSÁRLÓ!' },
  { name: 'N. Mária', city: 'Elégedett ügyfél', stars: 5, text: 'Nagyon szeretek ide járni. Udvariasak, segítőkészek. Mindent megoldanak!!!!!' },
  { name: 'V. Mónika', city: 'Elégedett ügyfél', stars: 5, text: 'Csak ajánlani tudom! Csodás az új paripám. Ha kell valami vagy kérdésed van szólj!' },
  { name: 'S. Ira Mihality', city: 'Baja', stars: 5, text: 'Rengeteg szép kerékpár és praktikus, mert szerviz is itt van.' },
  { name: 'K. Mária', city: 'Elégedett ügyfél', stars: 5, text: 'Gyors, megbízható, kedves emberek!!!' },
];

const ZTECH_SPECS = [
  { label: 'Motor teljesítmény', value: '250W', unit: 'brushless' },
  { label: 'Hatótáv', value: '80', unit: 'km+' },
  { label: 'Töltési idő', value: '4', unit: 'óra' },
  { label: 'Max sebesség', value: '25', unit: 'km/h' },
  { label: 'Akkumulátor', value: '36V', unit: 'Li-ion' },
  { label: 'Terhelhetőség', value: '120', unit: 'kg' },
];

const ZTECH_FEATURES = [
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
      </svg>
    ),
    title: 'Hatótáv 80 km+',
    desc: 'Nagy kapacitású lítium akkumulátor, egy töltéssel egész napos kerékpározás.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="2" y="7" width="16" height="10" rx="2"/>
        <path d="M22 11v2"/>
        <line x1="6" y1="11" x2="6" y2="13"/>
        <line x1="10" y1="9" x2="10" y2="15"/>
        <line x1="14" y1="11" x2="14" y2="13"/>
      </svg>
    ),
    title: 'Gyorstöltés 4h',
    desc: 'Standard háztartási aljzatból tölthető, 4 óra alatt teljesen feltöltődik.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <polyline points="9 12 11 14 15 10"/>
      </svg>
    ),
    title: 'Megbízható minőség',
    desc: 'Csak olyan modelleket kínálunk, amelyekben mi magunk is megbíznánk.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2"/>
        <line x1="12" y1="18" x2="12.01" y2="18" strokeWidth="2"/>
        <path d="M9 7h6M9 11h4"/>
      </svg>
    ),
    title: 'Okos vezérlés',
    desc: 'Bluetooth applikáción keresztül nyomon követheted a teljesítményt és az akkumulátor állapotát.',
  },
];

// ─── ANIMATED COUNTER ───────────────────────────────────────────────
function useCountUp(target, duration = 1800, startWhen = true) {
  const [count, setCount] = useState(0);
  const startRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!startWhen) return;
    startRef.current = null;

    const easeOutQuart = t => 1 - Math.pow(1 - t, 4);

    const step = (timestamp) => {
      if (!startRef.current) startRef.current = timestamp;
      const elapsed = timestamp - startRef.current;
      const progress = Math.min(elapsed / duration, 1);
      setCount(Math.floor(easeOutQuart(progress) * target));
      if (progress < 1) rafRef.current = requestAnimationFrame(step);
    };

    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [target, duration, startWhen]);

  return count;
}

// FIX 3: Mobile-friendly stat — compact font, no wrapping
function AnimatedStat({ num, suffix = '', label, duration = 1800, dark = false }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.4 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const count = useCountUp(num, duration, visible);

  return (
    <div ref={ref} style={{ textAlign: 'center', minWidth: 0 }}>
      <div style={{
        fontFamily: 'var(--font-display)',
        // FIX: clamp tightened — on very small screens stays on one line
        fontSize: 'clamp(1.6rem, 4vw, 5rem)',
        fontWeight: 900,
        color: dark ? 'white' : 'var(--coral)',
        lineHeight: 1,
        letterSpacing: '-0.02em',
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
      }}>
        {count}{suffix}
      </div>
      <div style={{
        fontSize: 'clamp(0.65rem, 1.8vw, var(--fs-sm))',
        color: dark ? 'rgba(255,255,255,0.6)' : 'var(--text-muted)',
        fontWeight: 500,
        marginTop: 6,
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap',
      }}>
        {label}
      </div>
    </div>
  );
}

// ─── STAR ROW ────────────────────────────────────────────────────────
function StarRow({ count }) {
  return (
    <div style={{ display: 'flex', gap: 3, marginBottom: 'var(--sp-4)' }}>
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="var(--peach)" stroke="none">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
      ))}
    </div>
  );
}

// ─── TESTIMONIAL CAROUSEL ────────────────────────────────────────────
// FIX 1: Full-width carousel — uses negative margin to break out of container
function TestimonialCarousel() {
  const trackRef = useRef(null);
  const pausedRef = useRef(false);
  const posRef = useRef(0);
  const animRef = useRef(null);
  const CARD_WIDTH = Math.min(340, typeof window !== 'undefined' ? window.innerWidth - 64 : 340);
  const GAP = 24;
  const STEP = CARD_WIDTH + GAP;
  const SPEED = 0.5;
  const items = [...TESTIMONIALS, ...TESTIMONIALS];
  const stepRef = useRef(STEP);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const totalWidth = TESTIMONIALS.length * stepRef.current;
    const animate = () => {
      if (!pausedRef.current) {
        posRef.current += SPEED;
        if (posRef.current >= totalWidth) posRef.current -= stepRef.current * TESTIMONIALS.length;
        track.style.transform = `translateX(-${posRef.current}px)`;
      }
      animRef.current = requestAnimationFrame(animate);
    };
    animRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animRef.current);
  }, []);

  return (
    // FIX 1: Breakout wrapper — stretches edge-to-edge regardless of parent container
    <div style={{
      width: '100vw',
      position: 'relative',
      left: '50%',
      right: '50%',
      marginLeft: '-50vw',
      marginRight: '-50vw',
      overflow: 'hidden',
      cursor: 'default',
      paddingLeft: 24,
    }}
      onMouseEnter={() => { pausedRef.current = true; }}
      onMouseLeave={() => { pausedRef.current = false; }}
    >
      <div ref={trackRef} style={{ display: 'flex', gap: GAP, width: 'max-content', willChange: 'transform' }}>
        {items.map((r, i) => (
          <div key={i} style={{
            width: CARD_WIDTH,
            flexShrink: 0,
            background: 'var(--bg)',
            borderRadius: 'var(--r-xl)',
            padding: 'var(--sp-7)',
            border: '1px solid var(--border)',
            display: 'flex',
            flexDirection: 'column',
            gap: 0,
          }}>
            <StarRow count={r.stars} />
            <p style={{
              fontSize: 'var(--fs-sm)',
              color: 'var(--text-2)',
              lineHeight: 1.75,
              marginBottom: 'var(--sp-5)',
              fontStyle: 'italic',
              flex: 1,
            }}>
              „{r.text}"
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-3)' }}>
              <div style={{
                width: 38,
                height: 38,
                borderRadius: '50%',
                background: 'var(--coral-light)',
                color: 'var(--coral)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'var(--font-display)',
                fontWeight: 700,
                fontSize: 'var(--fs-md)',
                flexShrink: 0,
              }}>
                {r.name[0].toUpperCase()}
              </div>
              <div>
                <div style={{ fontWeight: 600, color: 'var(--text)', fontSize: 'var(--fs-sm)' }}>{r.name}</div>
                <div style={{ fontSize: 'var(--fs-xs)', color: 'var(--text-muted)' }}>{r.city}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── ZTECH SPEC BAR ─────────────────────────────────────────────────
function ZTechSpecBar({ label, value, unit }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '14px 0',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
    }}>
      <span style={{ fontSize: 'var(--fs-sm)', color: 'rgba(255,255,255,0.55)', fontWeight: 500 }}>{label}</span>
      <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, color: 'white', fontSize: 'var(--fs-lg)' }}>
        {value} <span style={{ fontSize: 'var(--fs-xs)', color: 'rgba(255,255,255,0.45)', fontWeight: 500 }}>{unit}</span>
      </span>
    </div>
  );
}

// ─── HOME PAGE ────────────────────────────────────────────────────────
export default function Home() {
  const featured = allProducts.filter(p => p.is_featured).slice(0, 6).length >= 6
    ? allProducts.filter(p => p.is_featured).slice(0, 6)
    : allProducts.slice(0, 6);
  const loading = false;

  return (
    <>
      <SEO
        url="/"
        title="Kerékpár Webáruház Baja"
        description="Kerékpár szaküzlet Baján, Bács-Kiskun megye. 300+ modell: elektromos, túra, MTB, városi, gyermek kerékpár. Személyes beüzemelés, szakértő tanácsadás."
      />
      <main>
      {/* ─ HERO ─ */}
      <section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', minHeight: '88vh', overflow: 'hidden' }} className="hero-split">
        <style>{`
          @media (max-width: 768px) {
            .hero-split { grid-template-columns: 1fr !important; min-height: auto !important; }
            .hero-split__img { min-height: 320px !important; order: -1; }
            .hero-split__content { padding: 48px 24px !important; }
          }
        `}</style>

        {/* Bal oldal — szöveg */}
        <div className="hero-split__content" style={{ background: '#0D1B2A', display: 'flex', alignItems: 'center', padding: 'clamp(48px,8vw,96px) clamp(32px,5vw,72px)' }}>
          <div style={{ maxWidth: 520 }}>
            <div className="hero__eyebrow anim-fade-right" style={{ marginBottom: 20 }}>
              <span className="hero__eyebrow-dot" />Baja · Bács-Kiskun megye
            </div>

            <h1 className="anim-fade-right anim-d1" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(2rem,4vw,3.4rem)', fontWeight: 900, color: 'white', lineHeight: 1.1, letterSpacing: '-0.02em', marginBottom: 20 }}>
              Kerékpárszaküzlet<br /><em style={{ color: 'var(--coral)', fontStyle: 'normal' }}>és Szerviz</em> Baján
            </h1>

            <p className="anim-fade-right anim-d2" style={{ fontSize: 'clamp(0.95rem,1.5vw,1.1rem)', color: 'rgba(255,255,255,0.78)', lineHeight: 1.8, marginBottom: 32 }}>
              Bács-Kiskun megye egyik legnagyobb kerékpár szaküzlete Baján. 300+ modell — elektromos, túra, MTB, városi és gyermek kerékpárok. Gyere be hozzánk, személyesen segítünk a választásban!
            </p>

            <div className="anim-fade-right anim-d3" style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 48 }}>
              <Link to="/kerekparok" className="btn btn-primary btn-lg">
                Kerékpárok megtekintése
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </Link>
              <Link to="/kapcsolat" className="btn btn-lg" style={{ background: 'rgba(255,255,255,0.1)', color: 'white', border: '1.5px solid rgba(255,255,255,0.25)' }}>
                Kapcsolat
              </Link>
            </div>

            <div className="anim-fade-right anim-d4" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 32 }}>
              {[
                { num: '10+', label: 'Év tapasztalat' },
                { num: '5000+', label: 'Elégedett ügyfél' },
                { num: '300+', label: 'Kerékpár modell' },
              ].map((s, i) => (
                <div key={i}>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.5rem,3.2vw,2.2rem)', fontWeight: 800, color: 'var(--coral)', lineHeight: 1 }}>{s.num}</div>
                  <div style={{ fontSize: 'var(--fs-sm)', color: 'rgba(255,255,255,0.55)', fontWeight: 500, marginTop: 8, lineHeight: 1.3 }}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* Cím */}
            <div style={{ marginTop: 32, display: 'flex', alignItems: 'center', gap: 10 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              <span style={{ fontSize: 'var(--fs-xs)', color: 'rgba(255,255,255,0.45)' }}>6500 Baja, Czirfusz Ferenc u. 41. · Hétfő–Péntek 8–17h · Szombat 8–12h</span>
            </div>
          </div>
        </div>

        {/* Jobb oldal — kép */}
        <div className="hero-split__img" style={{ position: 'relative', overflow: 'hidden', minHeight: 500, background: '#0D1B2A' }}>
          {/* A fotó bal széle lágyan elolvad a sötét háttérszínbe (gradient blend maszk) */}
          <picture style={{
            position: 'absolute', inset: 0, width: '100%', height: '100%',
            WebkitMaskImage: 'linear-gradient(to right, transparent 0%, rgba(0,0,0,0.55) 12%, black 28%)',
            maskImage: 'linear-gradient(to right, transparent 0%, rgba(0,0,0,0.55) 12%, black 28%)',
          }}>
            <source srcSet="/uzlethero.webp" type="image/webp" />
            <img src="/uzlethero.png" alt="The Cruiser Shop kerékpárszaküzlet Baja – Czirfusz Ferenc u. 41."
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: '5% center' }} />
          </picture>
          {/* Finom korall fényfolt az átúsztatás vonalánál a "wow" hatásért */}
          <div style={{ position: 'absolute', left: '-12%', top: '50%', transform: 'translateY(-50%)', width: '46%', height: '70%', background: 'radial-gradient(circle, rgba(232,132,90,0.22) 0%, transparent 70%)', filter: 'blur(28px)', pointerEvents: 'none' }} />
        </div>
      </section>

      {/* ─ CATEGORIES ─ */}
      <section style={{ background: 'var(--bg)', padding: 'var(--sp-16) 0 0' }}>
        <div className="container" style={{ marginBottom: 'var(--sp-8)' }}>
          <FadeIn>
            <div className="section-header">
              <div className="section-eyebrow">Kategóriák</div>
              <h2 className="section-title">Találd meg a tökéletes bringát</h2>
            </div>
          </FadeIn>
        </div>
        {/* 2×3 kártyarács */}
        <div className="home-cat-grid" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:3 }}>
          {HOME_CATS.map((cat, i) => (
            <FadeIn key={cat.slug} direction="up" delay={i * 0.06}>
              <Link to={`/kerekparok?category=${cat.slug}`} style={{ display:'block', textDecoration:'none', position:'relative', overflow:'hidden', height:'clamp(200px,22vw,320px)', cursor:'pointer' }}
                onMouseEnter={e => { e.currentTarget.querySelector('img').style.transform='scale(1.08)'; e.currentTarget.querySelector('.hcat-cta').style.opacity='1'; e.currentTarget.querySelector('.hcat-cta').style.transform='translateY(0)'; }}
                onMouseLeave={e => { e.currentTarget.querySelector('img').style.transform='scale(1)'; e.currentTarget.querySelector('.hcat-cta').style.opacity='0'; e.currentTarget.querySelector('.hcat-cta').style.transform='translateY(6px)'; }}
              >
                {/* Kép */}
                <img src={cat.img} alt={cat.label} style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', transition:'transform 0.5s ease' }} />
                {/* Erős overlay */}
                <div style={{ position:'absolute', inset:0, background:`linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.45) 50%, rgba(0,0,0,0.15) 100%)` }} />
                {/* Színes tint */}
                <div style={{ position:'absolute', inset:0, background:`${cat.bg}55`, mixBlendMode:'multiply' }} />
                {/* Tartalom */}
                <div style={{ position:'absolute', bottom:0, left:0, right:0, padding:'clamp(14px,2.5vw,24px)' }}>
                  <div style={{ fontSize:'clamp(0.6rem,1vw,0.7rem)', fontWeight:700, color:cat.accent, letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:6 }}>{cat.count}</div>
                  <div style={{ fontFamily:'var(--font-display)', fontSize:'clamp(1.1rem,2.2vw,1.8rem)', fontWeight:800, color:'white', lineHeight:1.1, letterSpacing:'-0.01em', textShadow:'0 2px 8px rgba(0,0,0,0.5)', marginBottom:10 }}>{cat.label}</div>
                  <span className="hcat-cta" style={{ display:'inline-flex', alignItems:'center', gap:6, fontSize:'clamp(0.7rem,1.1vw,0.8rem)', fontWeight:700, color:cat.accent, background:'rgba(0,0,0,0.35)', backdropFilter:'blur(8px)', border:`1px solid ${cat.accent}66`, borderRadius:99, padding:'5px 14px', opacity:0, transform:'translateY(6px)', transition:'all 0.25s ease' }}>
                    Megnézem <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                  </span>
                </div>
              </Link>
            </FadeIn>
          ))}
        </div>
      </section>

      {/* ─ FEATURED PRODUCTS ─ */}
      <section className="section" id="featured" style={{ background: 'var(--white)' }}>
        <div className="container">
          <FadeIn>
            <div className="section-header" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', textAlign: 'left', marginBottom: 'var(--sp-10)', flexWrap: 'wrap', gap: 'var(--sp-4)' }}>
              <div>
                <div className="section-eyebrow">Kínálatunkból</div>
                <h2 className="section-title">Kiemelt kerékpárok</h2>
              </div>
              <Link to="/kerekparok" className="btn btn-outline" style={{ flexShrink: 0 }}>Összes megtekintése</Link>
            </div>
          </FadeIn>
          {loading ? (
            <div className="product-grid">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} style={{ borderRadius: 'var(--r-xl)', overflow: 'hidden', border: '1px solid var(--border)' }}>
                  <div className="skeleton" style={{ height: 220 }} />
                  <div style={{ padding: 20 }}>
                    <div className="skeleton" style={{ height: 12, width: '40%', marginBottom: 10 }} />
                    <div className="skeleton" style={{ height: 20, marginBottom: 6 }} />
                    <div className="skeleton" style={{ height: 16, width: '60%' }} />
                  </div>
                </div>
              ))}
            </div>
          ) : featured.length > 0 ? (
            <div className="product-grid">
              {featured.map((product, i) => (
                <FadeIn key={product.id} direction="up" delay={i * 0.07}>
                  <ProductCard product={product} />
                </FadeIn>
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-state__icon">🚲</div>
              <h3 className="empty-state__title">Hamarosan érkeznek a termékek</h3>
            </div>
          )}
        </div>
      </section>

      {/* ─ ELEKTROMOS SECTION ─ */}
      <section style={{ background: '#0A0A0F', overflow: 'hidden', position: 'relative' }}>
        {/* Background blobs */}
        <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: '-180px', left: '-180px', width: 'clamp(200px, 50vw, 600px)', height: 'clamp(200px, 50vw, 600px)', borderRadius: '50%', background: 'radial-gradient(circle, rgba(200,92,72,0.18) 0%, transparent 70%)' }} />
          <div style={{ position: 'absolute', bottom: '-100px', right: '-100px', width: 'clamp(150px, 35vw, 400px)', height: 'clamp(150px, 35vw, 400px)', borderRadius: '50%', background: 'radial-gradient(circle, rgba(232,164,85,0.12) 0%, transparent 70%)' }} />
          <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0.04 }} xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
                <path d="M 60 0 L 0 0 0 60" fill="none" stroke="white" strokeWidth="0.5"/>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
          </svg>
        </div>

        <div className="container" style={{ position: 'relative', paddingTop: 'var(--sp-20)', paddingBottom: 'var(--sp-20)' }}>

          {/* ── Centred header ── */}
          <FadeIn>
            <div style={{ textAlign: 'center', marginBottom: 'var(--sp-10)' }}>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(200,92,72,0.15)', border: '1px solid rgba(200,92,72,0.3)', borderRadius: 'var(--r-full)', padding: '6px 16px', marginBottom: 'var(--sp-5)' }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--coral)', boxShadow: '0 0 8px var(--coral)', animation: 'pulse 2s infinite' }} />
                <span style={{ fontSize: 'var(--fs-xs)', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--coral)' }}>Elektromos kerékpárok</span>
              </div>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(2rem, 4.5vw, 3.4rem)', fontWeight: 900, color: 'white', lineHeight: 1.1, letterSpacing: '-0.02em', marginBottom: 'var(--sp-4)' }}>
                Elektromos <span style={{ background: 'linear-gradient(90deg, var(--coral) 0%, var(--peach) 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>szabadság</span>, minden nap
              </h2>
              <p style={{ fontSize: 'var(--fs-md)', color: 'rgba(255,255,255,0.5)', lineHeight: 1.7, maxWidth: 520, margin: '0 auto' }}>
                Az elektromos kerékpáraink a legmodernebb technológiát ötvözik időtálló designnal. Tökéletes az ingázáshoz, a kikapcsolódáshoz és a kalandokhoz egyaránt.
              </p>
            </div>
          </FadeIn>

          {/* ── Two-column content ── */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 'var(--sp-6)', alignItems: 'start' }}>

            {/* Left: image + specs */}
            <FadeIn direction="left">
              <div>
                <div style={{ borderRadius: 24, overflow: 'hidden', position: 'relative', aspectRatio: '4/3', marginBottom: 'var(--sp-4)', border: '1px solid rgba(255,255,255,0.06)' }}>
                  <img src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1000&q=90" alt="Elektromos kerékpár" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(10,10,15,0.7) 0%, transparent 50%)' }} />
                  <div style={{ position: 'absolute', top: 16, right: 16, background: 'var(--coral)', color: 'white', fontSize: 'var(--fs-xs)', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', padding: '5px 12px', borderRadius: 'var(--r-full)', boxShadow: '0 4px 16px rgba(200,92,72,0.5)' }}>Bestseller</div>
                  <div style={{ position: 'absolute', bottom: 16, left: 20 }}>
                    <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 'var(--fs-lg)', color: 'white' }}>ZTech Urban Pro</div>
                    <div style={{ fontSize: 'var(--fs-sm)', color: 'rgba(255,255,255,0.6)' }}>7-fokozatú Shimano váltó · LCD kijelző</div>
                  </div>
                </div>
                <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: '6px 20px' }}>
                  {ZTECH_SPECS.map((spec, i) => <ZTechSpecBar key={i} {...spec} />)}
                </div>
              </div>
            </FadeIn>

            {/* Right: features + CTA */}
            <FadeIn direction="right">
              <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-3)' }}>
                {ZTECH_FEATURES.map((f, i) => (
                  <div key={i} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: '16px 20px', display: 'flex', alignItems: 'flex-start', gap: 14, transition: 'background 0.2s, border-color 0.2s, transform 0.2s', cursor: 'default' }}
                    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(200,92,72,0.08)'; e.currentTarget.style.borderColor = 'rgba(200,92,72,0.25)'; e.currentTarget.style.transform = 'translateX(4px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'; e.currentTarget.style.transform = ''; }}
                  >
                    <div style={{ width: 44, height: 44, flexShrink: 0, borderRadius: 12, background: 'rgba(200,92,72,0.12)', border: '1px solid rgba(200,92,72,0.2)', color: 'var(--coral)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{f.icon}</div>
                    <div>
                      <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--fs-md)', fontWeight: 700, color: 'white', marginBottom: 2 }}>{f.title}</h3>
                      <p style={{ fontSize: 'var(--fs-sm)', color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>{f.desc}</p>
                    </div>
                  </div>
                ))}
                <div style={{ background: 'linear-gradient(135deg, rgba(200,92,72,0.15) 0%, rgba(232,164,85,0.08) 100%)', border: '1px solid rgba(200,92,72,0.2)', borderRadius: 18, padding: '24px' }}>
                  <div style={{ fontSize: 'var(--fs-xs)', fontWeight: 700, letterSpacing: '0.10em', textTransform: 'uppercase', color: 'var(--peach)', marginBottom: 8 }}>Exkluzív ajánlat</div>
                  <p style={{ fontSize: 'var(--fs-sm)', color: 'rgba(255,255,255,0.7)', marginBottom: 16, lineHeight: 1.6 }}>250W motor, LCD kijelző, 7-fokozatú Shimano váltó — minden, amire szükséged van a tökéletes elektromos kerékpározáshoz.</p>
                  <Link to="/kerekparok?category=elektromos" className="btn btn-primary btn-lg btn-full">
                    Elektromos modellek
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                  </Link>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>

        <style>{`
          @keyframes pulse {
            0%, 100% { opacity: 1; box-shadow: 0 0 8px var(--coral); }
            50% { opacity: 0.5; box-shadow: 0 0 16px var(--coral); }
          }
        `}</style>
      </section>

      {/* ─ PROMO BANNER ─ */}
      <section style={{ background: 'linear-gradient(135deg, var(--coral) 0%, #A84835 100%)', padding: 'var(--sp-16) 0', overflow: 'hidden', position: 'relative' }}>
        <div style={{ position: 'absolute', right: '-60px', top: '-60px', width: 320, height: 320, borderRadius: '50%', background: 'rgba(255,255,255,0.06)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', right: '60px', top: '40px', width: 180, height: 180, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', pointerEvents: 'none' }} />
        <div className="container" style={{ position: 'relative' }}>
          <FadeIn>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 40, flexWrap: 'wrap' }}>
              <div>
                <p style={{ fontSize: 'var(--fs-sm)', fontWeight: 700, letterSpacing: '0.10em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.65)', marginBottom: 8 }}>Kerékpár szaküzlet Baján, Bács-Kiskun megyében</p>
                <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.8rem,4vw,2.8rem)', fontWeight: 700, color: 'white', lineHeight: 1.1, marginBottom: 12 }}>
                  Személyes beüzemelés<br />minden vásárláshoz
                </h2>
                <p style={{ fontSize: 'var(--fs-md)', color: 'rgba(255,255,255,0.8)', maxWidth: 480 }}>
                  Minden kerékpárt szakszerűen beüzemelünk és személyesen bemutatjuk a működését. Ingyenesen, minden vásárlásnál. Gyere be hozzánk Bajára!
                </p>
              </div>
              <div>
                <Link to="/kapcsolat" className="btn btn-white btn-lg">
                  Látogass be hozzánk
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </Link>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ─ WHY CHOOSE US ─ */}
      <section className="section" style={{ background: 'var(--bg)' }}>
        <div className="container">
          <FadeIn>
            <div className="section-header">
              <div className="section-eyebrow">Miért minket válassz</div>
              <h2 className="section-title">A Cruiser Shop különlegessége</h2>
            </div>
          </FadeIn>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 'var(--sp-5)' }}>
            {WHY.map((item, i) => (
              <FadeIn key={i} direction="up" delay={i * 0.08}>
                <div style={{ background: 'var(--white)', borderRadius: 'var(--r-xl)', border: '1px solid var(--border)', padding: 'var(--sp-7)', transition: 'box-shadow var(--t-base), transform var(--t-base)' }}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow = 'var(--shadow-lg)'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = ''; e.currentTarget.style.transform = ''; }}
                >
                  <div style={{ width: 52, height: 52, borderRadius: 'var(--r-md)', background: 'var(--coral-light)', color: 'var(--coral)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 'var(--sp-4)' }}>{item.icon}</div>
                  <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--fs-xl)', fontWeight: 700, color: 'var(--text)', marginBottom: 'var(--sp-2)' }}>{item.title}</h3>
                  <p style={{ fontSize: 'var(--fs-sm)', color: 'var(--text-muted)', lineHeight: 1.7 }}>{item.desc}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ─ TESTIMONIALS CAROUSEL ─ */}
<section className="section" style={{ background: 'var(--white)', paddingBottom: 'var(--sp-16)' }}>
  <div className="container">
    <FadeIn>
      <div className="section-header">
        <div className="section-eyebrow">Vélemények</div>
        <h2 className="section-title">Mit mondanak vevőink</h2>
        <p className="section-sub">Vidd rá az egeret a megállításhoz — olvasd el a véleményeket!</p>
      </div>
    </FadeIn>
  </div>
  <TestimonialCarousel />
  {/* ÚJ GOMB */}
  <div className="container">
    <FadeIn>
      <div style={{ textAlign: 'center', marginTop: 'var(--sp-10)' }}>
        <Link to="/rolunk" className="btn btn-outline btn-lg">
          Olvasd el az összes véleményt
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </Link>
      </div>
    </FadeIn>
  </div>
</section>

    </main>
    </>
  );
}